import { Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import * as S from "./styles";
import heroImg from "../assets/hero.svg";
import BookADemo from "../BookADemo";

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);
  const handleBookADemo = useCallback(() => setShowModal((s) => !s), []);

  return (
    <>
      <S.StyledHeroContainer>
        <S.StyledHeroColumn>
          <S.TitleTypography variant="mk_h1" fontWeight={500}>
            Partner with Us
          </S.TitleTypography>
          <Typography fontSize={28} fontWeight={700}>
            What We Do
          </Typography>
          <Typography variant="mk_subtitle">
            Health in Her HUE brings culturally tailored care, culturally
            relevant health content, and community support for Black women,
            women of color, and gender-expansive people of color. Learn how
            Health in her HUE can help your organization build trust and connect
            with underrepresented voices.
          </Typography>
          <S.StyledButtonWide onClick={handleBookADemo} variant="contained">
            Learn how we can Partner
          </S.StyledButtonWide>
        </S.StyledHeroColumn>
        <S.StyledHeroImg src={heroImg} aria-label="Black hand placing a puzzle piece, symbolizing collaboration and partnerships" />
      </S.StyledHeroContainer>
      <BookADemo isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default HeroSection;
